import React, { useEffect, useState } from 'react';
import { Button, Col, Container, Input, Row, Table } from 'reactstrap';
import { useNavigate } from 'react-router-dom';
import authService from '../api-authorization/AuthorizeService';
import utilities from '../util/utilities';
import AdminFunctions from './AdminFunctions';
import Session from '../auth/Session'


function Clients(props) {
    //const [search, clients, height, width] = useState(0);
    const navigate = useNavigate();
    //state = {
    //    search: null,
    //    clients: [],
    //    height: 0,
    //    width: 0
    //};

    const [query, setQuery] = useState(null);
    const [clients, setClients] = useState([]);
    const [height, setHeight] = useState(0);
    const [width, setWidth] = useState(0);


    //window.addEventListener('resize', setWindowDimensions);
    const getClients = async () => {
        const token = Session.getToken();
        const response = await fetch(`api/Clients/GetClients`, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        });
        const data = await response.json();
        setClients(data);
    }

    const searchClients = async () => {
        const token = Session.getToken();
        const response = await fetch(`api/Clients/SearchClients?query=${query}`, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        });
        const data = await response.json();
        setClients(data);
    }

    const handleRowClick = (clientId) => {
        navigate({
            pathname: '/admin/clients/details',
            state: { clientId: clientId, existingClient: true }
        });
    }

    const setWindowDimensions = () => {
        setHeight(window.innerHeight)
        setWidth(window.innerWidth);
    };

    useEffect(() => {
        async function fetchIsAdmin() {
            const isAdmin = AdminFunctions.isAdminAsync();
            if (!isAdmin) {
                navigate('/accessdenied');
            }
            setWindowDimensions();
            getClients();
        }
        fetchIsAdmin();        
    })


    return (
        <div>
            <Container style={{ marginTop: '50px' }}>
                <Row>
                    <Col>
                        <h3>Clients</h3>
                    </Col>
                </Row>
                <Row style={{ marginTop: '20px' }}>
                    <Col xl='10' lg='10' md='12' sm='12' xs='12'>
                        <Input
                            type='text'
                            onChange={(e) => setQuery(e.target.value)}
                            name='search'
                            id='search'
                            placeholder='Search'
                            style={width < utilities.dimensions.LG ? { marginBottom: '20px' } : {}}
                        />
                    </Col>
                    <Col xl='1' lg='1' md='2' sm='2' xs='2'>
                        <Button
                            color='primary'
                            onClick={() => searchClients()}
                        >
                            Search
                        </Button>
                    </Col>
                    <Col xl='1' lg='1' md='2' sm='2' xs='2'>
                        <Button
                            color='primary'
                            style={{ whiteSpace: 'nowrap' }}
                            onClick={() => navigate('/admin/clients/create')}
                        >
                            + Add
                        </Button>
                    </Col>
                </Row>
                <Row style={{ marginTop: '20px' }}>
                    <Col>
                        <Table bordered>
                            <thead>
                                <tr>
                                    <th>Id</th>
                                    <th>Name</th>
                                </tr>
                            </thead>
                            <tbody>
                                {clients.map((client, i) => {
                                    return (
                                        <tr
                                            key={client.id}
                                            onClick={() => handleRowClick(client.id)}
                                        >
                                            <td>{client.id}</td>
                                            <td>{client.name}</td>
                                        </tr>
                                    )
                                })}
                            </tbody>
                        </Table>
                    </Col>
                </Row>
            </Container>
        </div>
    )
}

export default Clients


